import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-698be64e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "view-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  class: "info"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "retry-container"
};
import { onMounted, onBeforeUnmount, ref, computed } from "vue";
import { preventAppRefresh, allowAppRefresh } from "@/utils/vue-helpers/log";
import { LogService } from "@/services/logging";
import { ComplianceErrorCodes, initializeComplianceLib } from "@/utils/helpers/compliance";
import ComplianceModule from "@/store/modules/compliance";
import { LocalStorageKeys } from "@/services/storage.service";
import { syncDeviceLocation } from "@/utils/helpers/device";
import DeviceModule from "@/store/modules/device";
import i18n from "@/lang"; // Simplified type alias to avoid TS2589 (excessively deep type instantiation)
// caused by vue-i18n v11's complex overloaded generics on i18n.global.t()

export default /*#__PURE__*/_defineComponent({
  __name: 'SellingDisabled',
  setup: function setup(__props) {
    var t = i18n.global.t;
    var refreshingComplianceStatus = ref(false);
    var hardwareUid = computed(function () {
      var _DeviceModule$hardwar;

      return DeviceModule.getHardwareHash || localStorage.getItem(LocalStorageKeys.manualHardwareUuid) || ((_DeviceModule$hardwar = DeviceModule.hardwareInfo) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.id) || "Unknown";
    });
    var salesDisabledText = computed(function () {
      return t("compliance.sales-disabled-content-global");
    });
    var errorCodes = computed(function () {
      var _DeviceModule$hardwar2;

      var codes = [];
      var packageInit = ComplianceModule.complianceStatus.packageInit;

      if (!packageInit) {
        codes.push(ComplianceErrorCodes.COMPLIANCE_LIB_INIT_FAILED);
      }

      if (!((_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar2 !== void 0 && _DeviceModule$hardwar2.deviceUid)) {
        codes.push(ComplianceErrorCodes.DEVICE_NOT_ASSIGNED);
      }

      if (!codes.length) {
        codes.push(ComplianceErrorCodes.UNKNWON_ERROR);
      }

      return codes.join(", ");
    });
    onMounted(function () {
      LogService.info("Disabled sales view mounted", {
        errorCodes: errorCodes
      });
      preventAppRefresh();
    });
    onBeforeUnmount(function () {
      LogService.info("Disabled sales view unmounted");
      allowAppRefresh();
    });

    function refreshComplianceStatus() {
      return _refreshComplianceStatus.apply(this, arguments);
    }

    function _refreshComplianceStatus() {
      _refreshComplianceStatus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var packageInit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                refreshingComplianceStatus.value = true;
                packageInit = ComplianceModule.complianceStatus.packageInit; // Check and sync device location if needed

                _context.next = 4;
                return syncDeviceLocation();

              case 4:
                if (packageInit) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 5;
                _context.next = 8;
                return initializeComplianceLib();

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](5);
                LogService.info("Failed to initialize compliance lib", {
                  error: _context.t0
                });

              case 13:
                refreshingComplianceStatus.value = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 10]]);
      }));
      return _refreshComplianceStatus.apply(this, arguments);
    }

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("compliance.sales-disabled")), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(salesDisabledText.value), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("compliance.error-codes")) + ": " + _toDisplayString(errorCodes.value), 1), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("complaince.hardware-uid")) + ": " + _toDisplayString(hardwareUid.value), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: refreshComplianceStatus,
        loading: refreshingComplianceStatus.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("label.refresh")), 1)];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});